export const environment = {
  production: true,
  tecnologies: '/assets/utils/technologies.json',
  config: '/assets/config',
  logosPath: '/assets/img/logos/',
  iconPath: '/assets/img/icons/',
  english: '/english.config.json',
  spanish: '/spanish.config.json',
};
